import {createAction} from '@reduxjs/toolkit'
import {PolicyBodyTypes} from 'interfaces'
import {PolicyUpdateField} from 'interfaces/Policy'

export const setShowCreatePolicyRP = createAction<boolean>(
  'setShowCreatePolicyRP',
)
export const createPolicy = createAction<{
  policyName: string
  callBackFunc: () => void
}>('createPolicy')
export const createPolicySuccess = createAction<{
  body: PolicyBodyTypes
  message: string
  policyName: string
}>('createPolicySuccess')
export const createPolicyFailure = createAction<string>('createPolicyFailure')

export const updatePolicyUpdateField = createAction<PolicyUpdateField>(
  'updatePolicyUpdateField',
)
export const resetPolicyUpdateField = createAction('resetPolicyUpdateField')
export const formSubmitted = createAction<boolean>('formSubmitted')
export const savePressed = createAction<boolean>('savePressed')

export const deletePolicy = createAction<{
  policyName: string
  callbackFunc: () => void
}>('deletePolicy')
export const deletePolicyFailure = createAction<string>('deletePolicyFailure')
export const deletePolicySuccess = createAction<string>('deletePolicySuccess')

export const resetPolicyList = createAction('resetPolicyList')

export const updatePolicyName = createAction<string>('updatePolicyName')
